import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_ORIGIN = "https://ghostedmd.com";
const DEFAULT_IMAGE = `${SITE_ORIGIN}/Images/ghosted-md-cover.webp`;
const TWITTER_SITE = "@nafsikasgarden";
const DATE_PUBLISHED = "2026-09-28T00:00:00+00:00";
const DATE_MODIFIED = "2026-10-06T00:00:00+00:00";

function setMeta(attribute, key, content) {
  let tag = document.head.querySelector(`meta[${attribute}="${key}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attribute, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function setJsonLd(id, data) {
  let script = document.getElementById(id);
  if (!script) {
    script = document.createElement("script");
    script.id = id;
    script.type = "application/ld+json";
    document.head.appendChild(script);
  }
  script.textContent = JSON.stringify(data);
}

function setLink(rel, href, hreflang) {
  const selector = hreflang
    ? `link[rel="${rel}"][hreflang="${hreflang}"]`
    : `link[rel="${rel}"]:not([hreflang])`;
  let tag = document.head.querySelector(selector);
  if (!tag) {
    tag = document.createElement("link");
    tag.setAttribute("rel", rel);
    if (hreflang) tag.setAttribute("hreflang", hreflang);
    document.head.appendChild(tag);
  }
  tag.setAttribute("href", href);
}

const PageMeta = ({ title, description, image = DEFAULT_IMAGE }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    const path = pathname === "/" ? "/" : pathname.replace(/\/$/, "");
    const url = `${SITE_ORIGIN}${path}`;

    document.title = title;
    setMeta("name", "description", description);
    setMeta("name", "robots", "index, follow");
    setLink("canonical", url);
    setLink("alternate", url, "en");
    setLink("alternate", url, "x-default");

    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", image);
    setMeta("property", "og:image:alt", title);
    setMeta("property", "og:site_name", "Ghosted MD");
    setMeta("property", "og:locale", "en_US");

    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:site", TWITTER_SITE);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", image);
    setMeta("property", "article:published_time", DATE_PUBLISHED);
    setMeta("property", "article:modified_time", DATE_MODIFIED);

    setJsonLd("page-jsonld", {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: title,
      description,
      url,
      datePublished: DATE_PUBLISHED,
      dateModified: DATE_MODIFIED,
      inLanguage: "en",
    });
  }, [title, description, image, pathname]);

  return null;
};

export default PageMeta;
